<template>
  <div>
    <MainHeader title="Support">
      <template #left>
        <font-awesome-icon
          :icon="['fas', 'arrow-left-long']"
          class="pointer"
          @click="router.push({ name: 'UserAccount' })"
        />
      </template>
    </MainHeader>

    <div class="view support-view">
      <div class="support-header">
        <h1 class="support-title">How can we help?</h1>
        <p class="support-sub">We're here for you — pick an option below.</p>
      </div>

      <div class="support-options">
        <button class="support-option-card" @click="browseHelpArticles">
          <div class="support-option-icon purple">
            <font-awesome-icon :icon="['fas', 'magnifying-glass']" />
          </div>
          <div class="support-option-text">
            <span class="support-option-title">Browse help articles</span>
            <span class="support-option-sub">Search our docs for answers</span>
          </div>
          <font-awesome-icon
            :icon="['fas', 'chevron-right']"
            class="support-option-chevron"
          />
        </button>

        <button class="support-option-card" @click="openHumanChat">
          <div class="support-option-icon teal">
            <font-awesome-icon :icon="['fas', 'comment']" />
          </div>
          <div class="support-option-text">
            <span class="support-option-title">Chat or message us</span>
            <span class="support-option-sub">Talk to a real person</span>
          </div>
          <font-awesome-icon
            :icon="['fas', 'chevron-right']"
            class="support-option-chevron"
          />
        </button>

        <button class="support-option-card" @click="openAIChat">
          <div class="support-option-icon blue">
            <font-awesome-icon :icon="['fas', 'robot']" />
          </div>
          <div class="support-option-text">
            <span class="support-option-title">Ask our AI assistant</span>
            <span class="support-option-sub">Get instant answers</span>
          </div>
          <font-awesome-icon
            :icon="['fas', 'chevron-right']"
            class="support-option-chevron"
          />
        </button>
      </div>

      <div class="support-note wrapper-card">
        <font-awesome-icon :icon="['fas', 'clock']" class="support-note-icon" />
        <div class="support-note-text">
          <p>
            We usually respond within a few hours during business days. Thanks
            for letting us be part of your financial journey!
          </p>
          <p class="mt-half">
            You can also email us directly at
            <strong>support@luckyfridayapp.com</strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from '../components/View-Header.vue';
import { useRouter } from 'vue-router';

export default {
  name: 'UserSupport',
  components: { MainHeader },
  setup() {
    const router = useRouter();

    const browseHelpArticles = () => {
      window.open('https://lucky-friday.helpscoutdocs.com/', '_blank');
    };

    const openAIChat = () => {
      if (window.Beacon && typeof window.Beacon === 'function') {
        window.Beacon('open');
        window.Beacon('navigate', '/answers/');
      } else {
        console.error('Beacon is not ready');
      }
    };

    const openHumanChat = () => {
      if (window.Beacon && typeof window.Beacon === 'function') {
        window.Beacon('open');
        window.Beacon('navigate', 'ask/chat');
      } else {
        console.error('Beacon is not ready');
      }
    };

    return { router, openHumanChat, browseHelpArticles, openAIChat };
  },
};
</script>

<style scoped>
.support-view {
  max-width: 480px;
  margin: 0 auto;
}

.support-header {
  text-align: center;
  padding: 1.5rem 0 1.25rem;
}
.support-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #004751;
  margin: 0 0 0.3rem;
  letter-spacing: -0.02em;
}
.dark-theme .support-title {
  color: white;
}
.support-sub {
  font-size: 0.82rem;
  color: #aaa;
  margin: 0;
}

.support-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 1.5rem;
}

.support-option-card {
  display: flex;
  align-items: center;
  gap: 14px;
  background: white;
  border: 1px solid #f0f0f0;
  border-radius: var(--radius-lg);
  padding: 1rem 1.1rem;
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  width: 100%;
  text-align: left;
  transition:
    transform var(--transition-base),
    box-shadow var(--transition-base);
  animation: cardSlideUp 0.35s cubic-bezier(0.34, 1.2, 0.64, 1) both;
  font-family: 'Poppins', sans-serif;
}
.dark-theme .support-option-card {
  background: #212e3e;
  border-color: #2a3a4e;
}
.support-option-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}
.support-option-card:active {
  transform: scale(0.98);
}

.support-option-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}
.support-option-icon.purple {
  background: var(--purple-50);
  color: var(--color-accent-purple);
}
.support-option-icon.teal {
  background: var(--teal-50);
  color: var(--color-accent-teal);
}
.support-option-icon.blue {
  background: #eef4ff;
  color: #3b82f6;
}
.dark-theme .support-option-icon.purple {
  background: #1e1a40;
}
.dark-theme .support-option-icon.teal {
  background: #0d2420;
}
.dark-theme .support-option-icon.blue {
  background: #0d1a30;
}

.support-option-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.support-option-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #213547;
}
.dark-theme .support-option-title {
  color: white;
}
.support-option-sub {
  font-size: 0.72rem;
  color: #aaa;
}

.support-option-chevron {
  font-size: 0.72rem;
  color: #ccc;
  flex-shrink: 0;
}
.dark-theme .support-option-chevron {
  color: #4a5a6e;
}

.support-note {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 1rem 1.1rem;
}
.support-note-icon {
  color: #aaa;
  font-size: 1rem;
  flex-shrink: 0;
  margin-top: 2px;
}
.support-note-text p {
  font-size: 0.8rem;
  color: #888;
  margin: 0;
  line-height: 1.55;
}
.dark-theme .support-note-text p {
  color: #888;
}
.mt-half {
  margin-top: 0.5rem;
}
</style>

<!-- <template>
  <div>
    <MainHeader title="Support">
      <template #left>
        <font-awesome-icon
          :icon="['fas', 'arrow-left-long']"
          class="pointer"
          @click="router.push({ name: 'UserAccount' })"
        />
      </template>
    </MainHeader>

    <div class="view support-page">
      <button
        class="blue-outline-button w-100 pt-4 pb-4 mb-2"
        @click="browseHelpArticles"
      >
        🔎 Browse help articles
      </button>
      <button
        class="blue-outline-button w-100 pt-4 pb-4 mb-2"
        @click="openHumanChat"
      >
        💬 Chat or Message Us
      </button>
      <button
        class="blue-outline-button w-100 pt-4 pb-4 mb-2"
        @click="openAIChat"
      >
        🤖 Ask our AI Assistant
      </button>

      <div class="wrapper-card closing-text ps-2 pe-2 small-grey-text">
        <div>
          We usually respond within a few hours during business days. Thanks for
          letting us be part of your financial journey!
        </div>
        <div>
          <p>
            If you prefer to email us directly you can reach us at
            support@luckyfridayapp.com
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from '../components/View-Header.vue';
import { useRouter } from 'vue-router';

export default {
  name: 'User-Support',
  components: {
    MainHeader,
  },
  setup() {
    const router = useRouter();

    const browseHelpArticles = () => {
      window.open('https://lucky-friday.helpscoutdocs.com/', '_blank');
    };

    const openAIChat = () => {
      if (window.Beacon && typeof window.Beacon === 'function') {
        window.Beacon('open');
        window.Beacon('navigate', '/answers/');
      } else {
        console.error('Beacon is not ready');
      }
    };

    const openHumanChat = () => {
      if (window.Beacon && typeof window.Beacon === 'function') {
        window.Beacon('open');
        window.Beacon('navigate', 'ask/chat');
      } else {
        console.error('Beacon is not ready');
      }
    };

    return {
      router,
      openHumanChat,
      browseHelpArticles,
      openAIChat,
    };
  },
};
</script>

<style scoped>
.support-page {
  padding: 1em;
  font-size: 1rem;
  line-height: 1.6;
}

.closing-text {
  margin-top: 2em;
  font-style: italic;
}
</style> -->
